module.exports = "\n\n<script src=\"https://www.rte.ie/djstatic/dotie/privacy/privacy.js?v=20231026v31731\"></script>";